export const stayType = [
    { id: 'Long-term care', name: 'Long-term care' },
    { id: 'Skilled', name: 'Skilled' },
    { id: 'Hospice', name: 'Hospice' },
    { id: 'Assisted living', name: 'Assisted living' },
];